import { BorderRadius, Color, FontSize, FontWeight, SkeletonCircle, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { ReactComponent as LogoPlaceholder } from '../../assets/images/organization-users-settings/logo-placeholder.svg'
import { Size } from './types/size'
import { getSizeStyles } from './utils/getSizeStyles'

const avatarCommonStyles = css`
  display: block;
  border-radius: ${BorderRadius.R12};
`

interface AvatarWrapperProps {
  noMargin?: boolean
  size: Size
}

export const AvatarWrapper = styled.div<AvatarWrapperProps>`
  margin-right: ${({ noMargin }) => (noMargin ? 0 : Spacing.S12)};
  border-radius: ${BorderRadius.R12};
  position: relative;
  background-color: ${Color.White};
  ${({ size }) => getSizeStyles(size)}
`
export const SkeletonAvatar = styled(SkeletonCircle)`
  position: absolute;
  top: 0;
  left: 0;
  ${avatarCommonStyles}
`

interface AvatarProps {
  isLoading: boolean
}

export const Avatar = styled.img<AvatarProps>`
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
  width: inherit;
  height: inherit;
  object-fit: cover;
  ${avatarCommonStyles}
`

export const AvatarPlaceholder = styled(LogoPlaceholder)`
  ${avatarCommonStyles}
`

interface AvatarInitialsProps {
  backgroundColor?: string
  size: Size
}

export const AvatarInitials = styled.div<AvatarInitialsProps>`
  ${avatarCommonStyles}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor ?? Color.Grey100};
  color: ${Color.Grey950};
  font-size: ${({ size }) => (size === 'l' ? FontSize.TextBodyLG : FontSize.TextBodySM)};
  font-weight: ${FontWeight.Regular};
`
